// extracted by mini-css-extract-plugin
export default {"checkbox":"MGInputCheckbox_checkbox__FMRKq","input":"MGInputCheckbox_input__YpD0Z","visual":"MGInputCheckbox_visual__GgLn1","icon":"MGInputCheckbox_icon__k5EjX"};